import _get from "lodash/get";
import _pick from "lodash/pick";
import logger from '@nerdwallet/home-app-lib/logger';
import transform from '@nerdwallet/transform';
import { sanitizeInputs } from '@nerdwallet/home-app-lib/sanitize';
import * as inputs from '../config/inputs';
import requestFromMarketplace from './get-program-from-marketplace';
export var RECEIVE_PROGRAMS = 'RECEIVE_PROGRAMS';
export var REQUEST_ERROR = 'REQUEST_ERROR';

var getInitializationProps = function getInitializationProps(state) {
  return _pick(_get(state, 'initializationProps', {}), ['product_id']);
};

export var getProgramFromMarketplace = function getProgramFromMarketplace(productId) {
  return function (dispatch) {
    return requestFromMarketplace(productId).then(function (data) {
      dispatch({
        type: RECEIVE_PROGRAMS,
        program: data
      });
    }).catch(function (err) {
      dispatch({
        type: REQUEST_ERROR,
        err: err
      });
    });
  };
};
export var bootstrapWidget = function bootstrapWidget(_ref) {
  var state = _ref.state,
      callback = _ref.callback;
  return function (dispatch) {
    var initializationProps = getInitializationProps(state);
    var sanitizedInitializationProps = sanitizeInputs(inputs, initializationProps);

    var _transform = transform({
      productId: 'product_id'
    }, sanitizedInitializationProps),
        productId = _transform.productId;

    dispatch(getProgramFromMarketplace(productId)).then(callback).catch(function (err) {
      logger.warn('widget-fthb-program-card bootstrapApp', err);
      callback();
    });
  };
};